import React, {Dispatch, SetStateAction, useEffect, useState} from 'react';
import {Formik} from "formik";
import s from "./PaymentByInternalTransactionTemplate.module.css";
import {Popover} from "antd";
import info from "../../../assets/img/personalAccount/information.svg";
import classnames from "classnames";
import {motion} from "framer-motion";
import {useAppDispatch, useAppSelector} from "../../../hooks/redux";
import CustomDropdownForAccounts from "../../ui/CustomDropdownForAccounts/CustomDropdownForAccounts";
import CustomDropdown from "../../ui/CustomDropdown/CustomDropdown";
import MyBtn from "../../ui/MyBtn/MyBtn";
import MyInput from "../../ui/MyInput/MyInput";
import TransparentButton from "../../ui/TransparentButton/TransparentButton";
import Icon from "@ant-design/icons";
import {ReactComponent as Back} from "../../../assets/img/personalAccount/back.svg";
import {useNavigate} from "react-router-dom";
import {
    getChallengeDataThunk,
    getFeesForTransaction,
    getTemplateByIdThunk
} from "../../../store/reducers/ActionCreators";
import {ITemplate} from "../../../types/interfaces";
import CustomModal from "../../ui/CustomModal/CustomModal";
import styles from "../../../styles/styles.module.css";
import {PrepareDataForLuxpayTransaction} from "../../../helpers/PrepareDataForLuxpayTransaction";
import { areLimitsExceeded } from '../../../helpers/LimitsHelper';
import PhoneCodesInput from "../../ui/PhoneCodesInput/PhoneCodesInput";
import AddDoc from "../../AddDoc/AddDoc";
import {setTransferDataPreview} from "../../../store/reducers/TransactionsSlice/TransactionsSlice";
import {setDisabled, setIsLoading} from "../../../store/reducers/UserSlice";

type PropsType = {
    id?: string | number;
    templateName: string,
    isButtonDisable: boolean,
    setPurpose: Dispatch<SetStateAction<string>>
    withdrawalStatus: string
}

const CurrencyHelper = (props: any) => {

    useEffect(() => {
        props.accountsList.map((account: any) => {

            if (account.number === props.accNumberFrom) {
                props.setCurrency(account.currency)
            }
        })
    }, [props.accountsList, props.accNumberFrom])

    return null
}

const PaymentByInternalTransactionTemplate = (props: PropsType) => {
    const accountsList = useAppSelector(state => state.userReducer.accountsList.accounts).filter((account: any) => account.accountMainIban !== "ALL")
    const navigate = useNavigate()
    const token = useAppSelector(state => state.userReducer.userToken)
    const accountId = useAppSelector(state => state.userReducer.chosenAccountTypeId)
    const dispatch = useAppDispatch()
    const [paymentToLuxPayTemplate, setPaymentToLuxPayTemplate] = useState<ITemplate>()
    const [currency, setCurrency] = useState('')
    const [isRequestDenied, setIsRequestDenied] = useState<boolean | null>(false)
    const [isAccountWrong, setIsAccountWrong] = useState<boolean | null>(false)
    const [isAvailableAccountExists, setIsAvailableAccountExists] = useState<boolean | null>(true)
    const [isPaymentSuccessfullyFinished, setIsPaymentSuccessfullyFinished] = useState<boolean | null>(null)
    const [localyDisabled, setLocalyDisabled] = useState(false)
    const [isDocumentErrorModalOpen, setIsDocumentErrorModalOpen] = useState<boolean | null>(false)
    const [documentErrorModalText, setDocumentErrorModalText] = useState<string | null>('')

    useEffect(() => {
        dispatch(getTemplateByIdThunk(token, props.id, accountId))
            .then((res) => {
                props.setPurpose('Transfer to a LuxPay User')
                setPaymentToLuxPayTemplate(res.data)
            })
    }, [])

    const transferMethods = [
        'Wallet Id',
        'email',
        'phone number'
    ]

    const limitsInfo = useAppSelector(state => state.userReducer.userLimits);
    const [isLimitPopupOpen, setIsLimitPopupOpen] = useState<boolean | null>(false)
    const [limitType, setLimitType] = useState<string | null>('');

    const errorAndRedirect = () => {
        setIsLimitPopupOpen(false)
        sessionStorage.removeItem("transfer-form")
        navigate('/personal-account/templates')
    }

    useEffect(() => {
        areLimitsExceeded(limitsInfo, setLimitType, setIsLimitPopupOpen);
    }, [])

    const getFees = async (obj: any) => {

        const preparedData = PrepareDataForLuxpayTransaction(obj, accountId)

        const resp = await dispatch(getFeesForTransaction(token, preparedData))

        return resp
    }

    const getChallengeData = async (obj: any) => {
        const preparedData = PrepareDataForLuxpayTransaction(obj, accountId)

        const resp = await dispatch(getChallengeDataThunk(token, {transaction: preparedData}))

        return resp
    }

    const accountType = [
        'personal',
        'business',
    ]

    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
            className={s.form_wrapper}
        >
            <Formik
                enableReinitialize={true}
                initialValues={{
                    accNumberFrom: paymentToLuxPayTemplate?.fromAccountMainIban,
                    accNumberTo: paymentToLuxPayTemplate?.toAccountUserNumber,
                    email: paymentToLuxPayTemplate?.recipientDetails?.email,
                    phoneNumber: paymentToLuxPayTemplate?.recipientDetails?.phone,
                    emailLanguage: 'EN',
                    amount: '',
                    invoice: {
                        name: '',
                        data: ''
                    },
                    purpose: paymentToLuxPayTemplate?.recipientDetails?.purpose,
                    transferCurrency: 'EUR',
                    reference: '',
                    transferMethod: paymentToLuxPayTemplate?.transferType
                        ? (paymentToLuxPayTemplate?.transferType === 'account' ? 'Wallet Id' : paymentToLuxPayTemplate?.transferType)
                        : 'Wallet Id',
                    hiddenAccountNumberTo: paymentToLuxPayTemplate?.toAccount,
                    hiddenAccountNumberFrom: paymentToLuxPayTemplate?.account,
                    accountType: paymentToLuxPayTemplate?.recipientType,
                }}
                onSubmit={async (values) => {
                    setLocalyDisabled(true)

                    let tempTransferMethod

                    if (values.transferMethod === 'phone number' || values.transferMethod === 'phone') {
                        tempTransferMethod = 'phone'
                    }

                    if (values.transferMethod === 'email') {
                        tempTransferMethod = 'email'
                    }

                    if (values.transferMethod === 'Wallet Id') {
                        tempTransferMethod = 'account'
                    }

                    let tempData = {
                        ...values,
                        accountId: accountId,
                        accountNumber: paymentToLuxPayTemplate?.account,
                        hiddenAccountNumber: paymentToLuxPayTemplate?.toAccount,
                        transferCurrency: currency,
                        type: 'internal',
                        clientId: paymentToLuxPayTemplate?.toAccountUserNumber,
                        transferMethod: tempTransferMethod
                    };

                    try {

                        const feesData = await getFees(tempData)

                        const challengeData = await getChallengeData(tempData)

                        const dataForPreview = {
                            ...tempData,
                            fee: feesData.data.fee,
                            totalAmount: feesData.data.totalAmount,
                            challengeData: challengeData.data
                        }

                        dispatch(setTransferDataPreview(dataForPreview))
                        navigate('/personal-account/templates/transfer-data-preview')
                    } catch (e: any) {

                        if (e.response.data === 'Daily Limit') {
                            setLimitType("daily")
                            setIsLimitPopupOpen(true)
                            return
                        } else if (e.response.data === 'Monthly Limit') {
                            setLimitType("monthly")
                            setIsLimitPopupOpen(true)
                            return
                        } else if (e.response.data.includes('User account is not active')) {
                            setDocumentErrorModalText('The user account is not active')
                            setIsDocumentErrorModalOpen(true)
                            return
                        } else {
                            setIsDocumentErrorModalOpen(true)
                            setDocumentErrorModalText('The transfer cannot be made due to insufficient funds.')
                        }
                    } finally {
                        setLocalyDisabled(false)
                    }
                }}
            >
                {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      handleSubmit,
                      setFieldValue
                  }) => (
                    <form onSubmit={handleSubmit}>

                        <CustomModal type="error" isNotify isModalOpen={isDocumentErrorModalOpen}
                                     setIsModalOpen={setIsDocumentErrorModalOpen}>
                            <div className={s.modal_content}>
                                <div className={s.popup_subtitle}>
                                    <span className={s.error}>Failed!</span> {documentErrorModalText}
                                </div>
                                <div className={s.popup_button_block}>
                                    <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"}
                                           onClick={() => setIsDocumentErrorModalOpen(null)}/>
                                </div>
                            </div>
                        </CustomModal>

                        <CustomModal type="error" isNotify isModalOpen={isAccountWrong}
                                     setIsModalOpen={setIsAccountWrong}>
                            <div className={s.modal_content}>
                                <div className={s.popup_subtitle}>
                                    <span className={s.error}>Failed!</span> The transfer cannot be made as currency of
                                    the payer account doesn't equal to currency of the recipient account.
                                </div>
                                <div className={s.popup_button_block}>
                                    <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={() => {
                                        setIsAccountWrong(false)
                                    }}/>
                                </div>
                            </div>
                        </CustomModal>

                        <CustomModal type="error" isNotify isModalOpen={!isAvailableAccountExists}
                                     setIsModalOpen={setIsAvailableAccountExists}>
                            <div className={s.modal_content}>
                                <div className={s.popup_subtitle}>
                                    <span className={s.error}>Failed!</span> The transfer cannot be made to the
                                    specified&nbsp;
                                    {values.transferMethod?.toLowerCase()} due to the lack of an account with the
                                    recipient.
                                </div>
                                <div className={s.popup_button_block}>
                                    <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={() => {
                                        setIsAvailableAccountExists(true)
                                    }}/>
                                </div>
                            </div>
                        </CustomModal>

                        <CustomModal type="error" isNotify isModalOpen={isRequestDenied}
                                     setIsModalOpen={setIsRequestDenied}>
                            <div className={s.modal_content}>
                                <div className={s.popup_subtitle}>
                                    <span className={s.error}>Failed!</span> Your request was rejected.
                                    <br/>Please try again.
                                </div>
                                <div className={s.popup_button_block}>
                                    <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={() => {
                                        navigate('/personal-account/templates')
                                    }}/>
                                </div>
                            </div>
                        </CustomModal>

                        <CustomModal type="error" isNotify isModalOpen={isPaymentSuccessfullyFinished === false}
                                     setIsModalOpen={setIsPaymentSuccessfullyFinished}>
                            <div className={styles.modal_content}>
                                <div className={styles.popup_subtitle}>
                                    <span className={styles.error}>Failed!</span> Something went wrong. Please try again
                                    or contact us.
                                </div>
                                <div className={styles.popup_button_block}>
                                    <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={() => {
                                        setIsPaymentSuccessfullyFinished(null)
                                    }}/>
                                </div>
                            </div>
                        </CustomModal>

                        <CustomModal type="error" isNotify isModalOpen={isLimitPopupOpen} setIsModalOpen={setIsLimitPopupOpen}>
                            <div className={styles.modal_content}>
                                <div className={styles.popup_subtitle}>
                                    <span className={styles.error}>Failed!</span> The transaction is impossible due to exceeding {limitType} limit.
                                    Please contact <a className={styles.popup_link} href='mailto:support@luxpay.lt'>support@luxpay.lt</a>&nbsp;
                                    if you have any questions.
                                </div>
                                <div className={styles.popup_button_block}>
                                    <MyBtn buttonType="error" isPersonalAccountBtn title={"Ok"} onClick={() => errorAndRedirect()} />
                                </div>
                            </div>
                        </CustomModal>

                        <div className={s.row}>
                            <div className={s.input_block}>
                                <div className={s.input_label}>
                                    <span><span className={s.red}>*</span> Payer account</span>
                                    <Popover content={"Please select the account you wish to make a transfer from."}
                                             color={'#EEEFEF'}
                                             overlayInnerStyle={{
                                                 fontFamily: 'Manrope',
                                                 width: '280px',
                                                 padding: '13px 16px',
                                                 cursor: 'pointer',
                                                 backgroundColor: '#E7F0EC'
                                             }}
                                    >
                                        <img src={info} alt=""/>
                                    </Popover>
                                </div>
                                <CustomDropdownForAccounts
                                    items={accountsList}
                                    placeholder={"Please select the account"}
                                    id="accNumberFrom"
                                    name="accNumberFrom"
                                    isError={errors.accNumberFrom}
                                    touched={touched.accNumberFrom}
                                    setAccountNumber={() => {}}
                                    disabled={props.id !== 'create'}
                                    setCurrency={(selectedCurrency) => {
                                        setCurrency(selectedCurrency);
                                    }}
                                />
                                {errors.accNumberFrom &&
                                    <div className={s.error_message}>{errors.accNumberFrom}</div>}
                            </div>

                            <div className={s.input_block}>
                                <div className={s.input_label}>
                                    <span><span className={s.red}>*</span> Transfer Method</span>
                                    <Popover content={"Choose one of the recipient’s identifiers: their LuxPay" +
                                        " account, email address or phone number."}
                                             color={'#EEEFEF'}
                                             overlayInnerStyle={{
                                                 fontFamily: 'Manrope',
                                                 width: '280px',
                                                 padding: '13px 16px',
                                                 cursor: 'pointer',
                                                 backgroundColor: '#E7F0EC'
                                             }}
                                    >
                                        <img src={info} alt=""/>
                                    </Popover>
                                </div>
                                <CustomDropdown
                                    items={transferMethods}
                                    id="transferMethod"
                                    name="transferMethod"
                                    isError={errors.transferMethod}
                                    touched={touched.transferMethod}
                                    disable={props.id !== 'create'}
                                />
                            </div>
                        </div>

                        <div className={s.block}>
                            <div className={s.title}>
                                Outgoing Payment Details
                            </div>

                            <div className={s.row}>

                                <div className={s.input_block}>
                                    {values.transferMethod === 'Wallet Id'
                                        && <div className={s.input_block}>
                                            <div className={s.input_label}>
                                                <span><span className={s.red}>*</span> Wallet ID</span>
                                            </div>
                                            <MyInput id={"accNumberTo"}
                                                     name={"accNumberTo"}
                                                     touched={touched.accNumberTo}
                                                     value={values.accNumberTo}
                                                     onChange={handleChange}
                                                     isError={errors.accNumberTo}
                                                     placeholder={"Enter wallet id"}
                                                     disabled={props.id !== 'create'}
                                            />
                                            {errors.accNumberTo &&
                                                <div className={s.error_message}>{errors.accNumberTo}</div>}
                                        </div>
                                    }

                                    {values.transferMethod === 'email'
                                        && <div className={s.input_block}>
                                            <div className={s.input_label}>
                                                *Email
                                            </div>
                                            <MyInput id={"email"}
                                                     name={"email"}
                                                     touched={touched.email}
                                                     value={values.email}
                                                     onChange={handleChange}
                                                     isError={errors.email}
                                                     disabled={props.id !== 'create'}
                                            />
                                            {errors.email &&
                                                <div className={s.error_message}>{errors.email}</div>}
                                        </div>
                                    }

                                    {(values.transferMethod === 'phone number' || values.transferMethod === 'phone')
                                        && <div className={s.input_block}>
                                            <div className={s.input_label}>
                                                <span><span className={s.red}>*</span> phone number</span>
                                                <Popover
                                                    content={"Phone number in international format."}
                                                    color={'#EEEFEF'}
                                                    overlayInnerStyle={{
                                                        fontFamily: 'Manrope',
                                                        width: '280px',
                                                        padding: '13px 16px',
                                                        cursor: 'pointer',
                                                        backgroundColor: '#E7F0EC'
                                                    }}
                                                >
                                                    <img src={info} alt=""/>
                                                </Popover>
                                            </div>
                                            <PhoneCodesInput
                                                id="phoneNumber"
                                                name="phoneNumber"
                                                error={errors.phoneNumber}
                                                touched={touched.phoneNumber}
                                                disabled={props.id !== 'create'}
                                                tiny
                                            />
                                        </div>
                                    }

                                </div>

                                <div className={s.input_block}>
                                    <div className={s.input_label}>
                                        Purpose
                                    </div>
                                    <MyInput id={"purpose"}
                                             name={"purpose"}
                                             touched={touched.purpose}
                                             value={values.purpose}
                                             onChange={handleChange}
                                             isError={errors.purpose}
                                             placeholder={"Enter your purpose of payment"}
                                             disabled={props.id !== 'create'}
                                    />
                                    {errors.purpose && <div className={s.error_message}>{errors.purpose}</div>}
                                </div>

                            </div>


                            <div className={s.row}>

                                <div className={s.mobile_row}>
                                    <div className={classnames(s.input_block, s.short)}>
                                        <div className={s.input_label}>
                                            <span><span className={s.red}>*</span> Amount</span>
                                            <Popover content={"Select a currency and enter the transfer amount.\n" +
                                                "In the account balance in the selected currency is insufficient, the system " +
                                                "will automatically offer you to top up using funds in a different currency " +
                                                "you have on the account."}
                                                     color={'#EEEFEF'}
                                                     overlayInnerStyle={{
                                                         fontFamily: 'Manrope',
                                                         width: '280px',
                                                         padding: '13px 16px',
                                                         cursor: 'pointer',
                                                         backgroundColor: '#E7F0EC'
                                                     }}
                                            >
                                                <img src={info} alt=""/>
                                            </Popover>
                                        </div>
                                        <MyInput id={"amount"}
                                                 name={"amount"}
                                                 value={values.amount}
                                                 onChange={handleChange}
                                                 isError={errors.amount}
                                        />
                                        {errors.amount && <div className={s.error_message}>{errors.amount}</div>}
                                    </div>

                                    <div className={s.currency_dropdown}>
                                        <div className={s.input_label}>
                                        </div>
                                        <MyInput
                                            id="transferCurrency"
                                            name="transferCurrency"
                                            value={currency}
                                            disabled={true}
                                        />
                                    </div>

                                </div>

                                {
                                    values.accountType && <div className={s.input_block}>
                                        <div className={s.input_label}>
                                                <span><span
                                                    className={s.red}>*</span> RECIPIENT ACCOUNT TYPE</span>
                                        </div>
                                        <CustomDropdown
                                            items={accountType}
                                            id="accountType"
                                            name="accountType"
                                            isError={errors.accountType}
                                            touched={touched.accountType}
                                            disable={true}
                                        />
                                        {errors.accountType && touched.accountType &&
                                            <div className={s.error_message}>{errors.accountType}</div>}
                                    </div>
                                }


                            </div>

                        </div>

                        <AddDoc
                            invoice={values.invoice}
                            setIsDocumentErrorModalOpen={setIsDocumentErrorModalOpen}
                            setDocumentErrorModalText={setDocumentErrorModalText}
                            setFieldValue={setFieldValue}
                        />

                        <div className={s.continue_block}>
                            <div className={s.required}>
                                <div>
                                    <span><span className={s.red}>*</span> required fields.</span>
                                </div>
                            </div>
                        </div>

                        <div className={s.buttonsWrapper}>
                            <div className={s.button_block}>
                                <TransparentButton title={'Back'}
                                                   isPersonalAccountBtn
                                                   large
                                                   icon={<Icon component={() => <Back/>} rev={undefined}/>}
                                                   onClick={() => {
                                                       navigate(-1);
                                                   }}/>
                            </div>

                            <MyBtn title={'Continue'}
                                   large
                                   style={{width: 180}}
                                   type="submit"
                                   isPersonalAccountBtn
                                   localDisable={(props.id !== 'create' && props.isButtonDisable) || localyDisabled}
                                   onClick={() => {
                                       handleSubmit();
                                   }}
                            />
                        </div>

                        <CurrencyHelper
                            accountsList={accountsList}
                            setCurrency={setCurrency}
                            accNumberFrom={values.hiddenAccountNumberFrom}
                        />

                    </form>
                )}
            </Formik>
        </motion.div>
    );
};

export default PaymentByInternalTransactionTemplate;
